
import { bsAnimation, homeAnimation, circleSlider } from './animations';
import barba from '@barba/core';
import { gsap } from "gsap";

barba.hooks.enter(() => {
    //useful for google analytics
    window.scrollTo(0, 0);

})

barba.hooks.afterLeave(() => {
    console.log("hook leave");
    let triggers = ScrollTrigger.getAll();
    triggers.forEach(trigger => {
        trigger.kill();
    });
});


barba.hooks.after(() => {
    console.log("hooks after");
    initMenu();
    if (location.hash) {
        console.log("hash: " + location.hash);
        //remove # from the string
        var elId = location.hash.replace('#', '');
        //locate the anchored element on the page by its ID property 
        var scrollToEl = document.getElementById(elId);
        //scroll to the anchored element
        scrollToEl.scrollIntoView(true);
        // gsap.to(window, {duration: 2, scrollTo: {y: location.hash, offsetY: 0}});
    } 
    gtag('event', 'page_view', {
        'page_title': document.title,
        'page_location': location.href,
        'page_path': location.pathname,
    });
    
})


const animationLeave = (container, done) => {
    console.log("animation leave");
    return gsap.to(container, {
        autoAlpha: 0,
        duration: 0.3,
        delay: 0.4,
        clearProps: 'all',
        onComplete: () => {
            done();
        }
    });
}
const animationEnter = (container) => {
    console.log("animation enter");
    return gsap.from(container, {
        autoAlpha: 0,
        duration: 0.5,
        clearProps: 'all',
    });
}

const initMenu = () => {
    console.log("init menu initialised")
    var navi = $("nav")
    $(".navtrigger, .menutext, .links").click(function () {
        console.log("triggered toggle menu");
        if (navi.hasClass('open')) {
            navi.removeClass('open');
            navi.addClass('closed');
        } else {
            navi.removeClass('closed init');
            navi.addClass('open');
        }
    });

    $("[data-subj]").click(function () {
        var $this = $(this);
        $("[data-subj]").removeClass("bg-yellow");
        $("[data-subj]").addClass("bg-menu_grey");
        $this.toggleClass("bg-menu_grey bg-yellow");
        var subj = $this.data("subj");
        $("#subject").val(subj);
        // console.log("new subject = " + subj);
    });


}


barba.init({
    views: [
        {
            namespace: 'home',
            afterEnter(data) {
                console.log("after enter home call homeAnimation");
                homeAnimation();
            }
        },
        {
            namespace: 'bs',
            afterEnter(data) {
                console.log("after enter bs");
                bsAnimation();
            }
        },
        {
            namespace: 'contact',
            afterEnter(data) {
                console.log("after enter contact");
                circleSlider();
            },

        },

    ],
    transitions: [
        {
            name: 'opacity-transition',
            once(data) {
                animationEnter(data.next.container)
            },
            leave(data) {
                const done = this.async()
                animationLeave(data.current.container, done)
            },
            enter(data) {
                animationEnter(data.next.container)

            },
            afterEnter() {
                // console.log("afterenter");

            }
        },

    ]
});

$(document).ready(function () {
    initMenu();
});